(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-client-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const checkbox = document.getElementById('B2BClientForm-same-as-invoice');
    const shipmentFields = document.getElementById('shipment-fields');
    const form = document.querySelector('.b2b-client-form__form');
    
    if (checkbox && shipmentFields) {
      // Function to toggle shipment fields visibility
      function toggleShipmentFields() {
        if (checkbox.checked) {
          shipmentFields.classList.add('hidden');
          // Make fields not required when hidden
          const requiredFields = shipmentFields.querySelectorAll('[required]');
          requiredFields.forEach(field => {
            field.removeAttribute('required');
            field.setAttribute('aria-required', 'false');
            field.disabled = true;
          });
        } else {
          shipmentFields.classList.remove('hidden');
          // Make fields required when visible
          const requiredFields = shipmentFields.querySelectorAll('[aria-required="false"]');
          requiredFields.forEach(field => {
            field.setAttribute('required', '');
            field.setAttribute('aria-required', 'true');
            field.disabled = false;
          });
        }
      }
      
      // Add event listener
      checkbox.addEventListener('change', toggleShipmentFields);
      
      // Initialize state
      toggleShipmentFields();
    }

    // Mobile-specific improvements
    if (form) {
      // Add touch-friendly focus states for mobile
      const inputs = form.querySelectorAll('input, textarea, select');
      
      inputs.forEach(input => {
        // Add touch-friendly focus handling
        input.addEventListener('focus', function() {
          this.parentElement?.classList.add('focused');
        });
        
        input.addEventListener('blur', function() {
          this.parentElement?.classList.remove('focused');
        });

        // Improve mobile input experience
        if (input.type === 'tel') {
          // Add pattern for better mobile keyboard
          input.setAttribute('pattern', '[0-9\\+\\-\\s\\(\\)]*');
        }

        if (input.type === 'email') {
          // Add autocorrect and autocapitalize attributes for better mobile experience
          input.setAttribute('autocorrect', 'off');
          input.setAttribute('autocapitalize', 'off');
          input.setAttribute('spellcheck', 'false');
        }
      });

      // Add form validation feedback using button click event
      const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
      
      if (submitButton) {
        submitButton.addEventListener('click', function(e) {
          const requiredFields = form.querySelectorAll('[required]');
          let hasErrors = false;
          
          requiredFields.forEach(field => {
            if (!field.value.trim()) {
              field.classList.add('error');
              hasErrors = true;
            } else {
              field.classList.remove('error');
            }
          });

          // Email validation
          const emailFields = form.querySelectorAll('input[type="email"]');
          emailFields.forEach(field => {
            if (field.value && !isValidEmail(field.value)) {
              field.classList.add('error');
              hasErrors = true;
            }
          });
          
          // If there are errors, prevent the form from submitting
          if (hasErrors) {
            e.preventDefault();
            e.stopPropagation();
            
            // Generate error list with specific field names
            const errorList = [];
            const errorFields = form.querySelectorAll('.error');
            
            errorFields.forEach(field => {
              let fieldName = '';
              
              // Get field label from the associated label element
              const fieldId = field.id;
              if (fieldId) {
                const label = document.querySelector(`label[for="${fieldId}"]`);
                if (label) {
                  // Get the text content and remove any asterisk
                  fieldName = label.textContent.replace('*', '').trim();
                }
              }
            
              // Add field name to error list (just the label)
              if (fieldName) {
                errorList.push(fieldName);
              }
            });
            
            // Show error message with specific field names
            const errorContainer = document.getElementById('client-validation-error');
            if (errorContainer) {
              const errorListElement = errorContainer.querySelector('.b2b-client-form__error-list');
              if (errorListElement) {
                errorListElement.innerHTML = errorList.map(error => `<li>${error}</li>`).join('');
              }
              errorContainer.style.display = 'flex';
              errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            
            // Scroll to first error
            const firstError = form.querySelector('.error');
            if (firstError) {
              firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
              firstError.focus();
            }
          } else {
            // Hide error message if form is valid
            const errorContainer = document.getElementById('client-validation-error');
            if (errorContainer) {
              errorContainer.style.display = 'none';
            }
          }
          // If there are no errors, the form will submit normally
        });
      }

      // Real-time validation feedback
      inputs.forEach(input => {
        input.addEventListener('blur', function() {
          if (this.hasAttribute('required') && !this.value.trim()) {
            this.classList.add('error');
          } else if (this.type === 'email' && this.value && !isValidEmail(this.value)) {
            this.classList.add('error');
          } else {
            this.classList.remove('error');
          }
        });

        input.addEventListener('input', function() {
          if (this.classList.contains('error')) {
            this.classList.remove('error');
          }
        });
      });
    }

    // Email validation helper
    function isValidEmail(email) {
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      return emailRegex.test(email);
    }

    // Add mobile-specific CSS for error states
    const style = document.createElement('style');
    style.textContent = `
      .b2b-client-form__input.error {
        border-color: var(--color-error);
        border-width: 2px;
        box-shadow: 0 0 0 2px rgb(var(--color-error-rgb) / 0.2);
      }
      
      .b2b-client-form__form-row.focused {
        position: relative;
      }
      
      .b2b-client-form__error {
        display: flex;
        align-items: flex-start;
        gap: var(--gap-xs);
        padding: var(--gap-md);
        border-radius: var(--style-border-radius-inputs);
        margin-bottom: var(--gap-md);
        background-color: rgb(var(--color-error-rgb) / 0.1);
        border: 1px solid var(--color-error);
        color: var(--color-error);
      }
      
      .b2b-client-form__error svg {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        margin-top: 2px;
      }
      
      .b2b-client-form__error-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: var(--gap-xs);
      }
      
      .b2b-client-form__error-heading {
        font-weight: 600;
        margin-bottom: var(--gap-xs);
      }
      
      .b2b-client-form__error-list {
        margin: 0;
        padding-left: var(--gap-md);
        list-style-type: disc;
      }
      
      .b2b-client-form__error-list li {
        margin-bottom: var(--gap-xs);
        line-height: 1.4;
      }
      
      @media screen and (max-width: 749px) {
        .b2b-client-form__input.error {
          animation: shake 0.5s ease-in-out;
        }
        
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
      }
    `;
    document.head.appendChild(style);
  });
  } catch(e) { console.error(e); }
})();

})();
